<template>
  <el-drawer :title="title" :visible.sync="visible" direction="rtl" size="90%">
    <template slot="title">
      <div style="width: 100%; display: flex; align-items: center">
        <el-button
          type="primary"
          @click="visible = false"
          style="margin-right: 10px"
          >关闭</el-button
        >
        <div>{{ title }}</div>
      </div>
    </template>
    <div class="drawer-content" v-loading="btnLoading">
      <el-row class="form">
        <el-col :span="8">
          <div class="formItem">
            <label class="label">
              <span style="color: red">*</span>移交任务名称
            </label>
            <el-input
              v-model="form.Name"
              placeholder="请输入移交任务名称"
              style="flex: 1"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="formItem">
            <label class="label">
              <span style="color: red">*</span>供应商
            </label>
            <el-select
              v-model="form.SupplierId"
              multiple
              filterable
              :collapse-tags="true"
              clearable
              placeholder="请选择供应商"
              style="flex: 1"
              :disabled="SupplierIddisabled"
            >
              <el-option
                v-for="item in SupplierData"
                :key="item.Id"
                :label="item.title"
                :value="item.Id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="移交设备清单" name="0"></el-tab-pane>
        <el-tab-pane label="移交通用配件清单" name="1"></el-tab-pane>
        <el-tab-pane label="移交项目资料清单" name="2"></el-tab-pane>
        <el-tab-pane label="移交资质资料清单" name="3"></el-tab-pane>
      </el-tabs>
      <div class="container" v-if="activeName === '0'">
        <deviecTransfer
          ref="deviecTransfer"
          v-model="deviecData"
          :DeviceTypeData="DeviceTypeData"
          :pId="pId"
          :SupplierId="form.SupplierId"
        ></deviecTransfer>
      </div>
      <div class="container" v-if="activeName === '1'">
        <AccessoryTransfer
          ref="AccessoryTransfer"
          v-model="AccessoryData"
          :DeviceTypeData="DeviceTypeData"
          :pId="pId"
          :SupplierId="form.SupplierId"
        ></AccessoryTransfer>
      </div>
      <div class="container" v-if="activeName === '2'">
        <FilesDataTransfer
          ref="FilesDataTransfer"
          v-model="FilesData"
          :DeviceTypeData="DeviceTypeData"
          :pId="pId"
          :SupplierId="form.SupplierId"
        ></FilesDataTransfer>
      </div>
      <div class="container" v-if="activeName === '3'">
        <TypeFilesTransfer
          ref="TypeFilesTransfer"
          v-model="TypeFiles"
          :DeviceTypeData="DeviceTypeData"
          :pId="pId"
          :SupplierId="form.SupplierId"
        ></TypeFilesTransfer>
      </div>

      <!-- 底部按钮 -->
      <div class="drawer-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">
          保存
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import deviecTransfer from './transfer/deviecTransfer.vue'
import AccessoryTransfer from './transfer/AccessoryTransfer.vue'
import FilesDataTransfer from './transfer/FilesDataTransfer.vue'
import TypeFilesTransfer from './transfer/TypeFilesTransfer.vue'
export default {
  components: {
    deviecTransfer,
    AccessoryTransfer,
    FilesDataTransfer,
    TypeFilesTransfer,
  },
  props: {
    parentObj: {
      type: Object,
      require: true,
    },
    pId: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      title: '',
      visible: false,
      activeName: '0',
      btnLoading: false,
      // 供应商数据
      SupplierData: [],
      // 设备类型数据
      DeviceTypeData: [],
      //设备移交数据
      deviecData: [],
      //配件移交数据
      AccessoryData: [],
      //项目资料移交数据
      FilesData: [],
      //资质移交数据
      TypeFiles: [],
      form: {
        Name: '',
        SupplierId: [],
      },
    }
  },
  computed: {
    SupplierIddisabled() {
      return (
        this.deviecData.length > 0 ||
        this.AccessoryData.length > 0 ||
        this.FilesData.length > 0 ||
        this.TypeFiles.length > 0
      )
    },
  },
  methods: {
    deviecTransferChange(rows) {
      console.log(rows, 'sssss')
      this.rightData = [...rows]
    },
    getSupplierData() {
      this.$http
        .post(
          `/Base_ProjectWork/Base_ProjectSupplier/GetProjectSupplierTree?ProjectId=${this.pId}&Type=1`
        )
        .then((res) => {
          if (res.Success) {
            this.SupplierData = res.Data
          }
        })
    },
    getDeviceTypeData() {
      this.$http
        .post(
          `/Base_ProjectWork/project_taskhandover/GetProjectDeviceData?ProjectId=${this.pId}`
        )
        .then((res) => {
          if (res.Success) {
            this.DeviceTypeData = res.Data[0]?.children || []
          }
        })
    },

    // 打开组件
    open(title) {
      this.title = title
      this.form = {
        Name: '',
        SupplierId: [],
      }
      this.deviecData = []
      this.FilesData = []
      this.AccessoryData = []
      this.TypeFiles = []

      this.visible = true
      this.activeName = '0'
    },

    // 保存操作
    handleSubmit() {
      if (this.form.Name === '') {
        return this.$notify.error('请填写移交任务名称')
      }
      if (!this.form.SupplierId.length) {
        return this.$notify.error('请填写供应商')
      }
      if (this.deviecData.length === 0) {
        return this.$notify.error('请至少选择一项设备')
      }
      this.$confirm('确定要保存吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let deviecData = this.deviecData.map((item) => ({
          ...item,
          DataId: item.Id,
          InfoType: '0',
        }))
        let AccessoryData = this.AccessoryData.map((item) => ({
          ...item,
          DataId: item.Id,
          InfoType: '3',
        }))
        let FilesData = this.FilesData.map((item) => ({
          ...item,
          DataId: item.Id,
          InfoType: '4',
          FileType: item.Type,
        }))
        let TypeFiles = this.TypeFiles.map((item) => ({
          ...item,
          DataId: item.Id,
          InfoType: '5',
          FileType: item.Type,
        }))
        let DeviceQty = this.deviecData.reduce((acc, item) => {
          return acc + item.Num
        }, 0)
        let AccessoryQty = this.AccessoryData.reduce((acc, item) => {
          return acc + item.Nums
        }, 0)
        let ProjectFilesQty = this.FilesData.length
        let SupFilesQty = this.TypeFiles.length
        this.btnLoading = true
        this.$http
          .post('/Base_ProjectWork/project_taskhandover/SaveProjectTaskData', {
            project_taskhandover: {
              ...this.form,
              ProjectId: this.pId,
              SupplierId: this.form.SupplierId.join(','),
              DeviceQty,
              AccessoryQty,
              ProjectFilesQty,
              SupFilesQty,
            },
            project_Taskhandoverdetails: [
              ...deviecData,
              ...FilesData,
              ...AccessoryData,
              ...TypeFiles,
            ],
          })
          .then((res) => {
            this.btnLoading = false
            if (res.Success) {
              this.$emit('success')
              this.$notify.success('操作成功')
              this.visible = false
            } else {
              this.$notify.error(res.Msg)
            }
          })
          .catch(() => {
            this.btnLoading = false
            this.$notify.error('操作失败')
          })
      })
    },
  },
  created() {
    this.getSupplierData()
    this.getDeviceTypeData()
  },
}
</script>

<style lang="scss" scoped>
.drawer-content {
  width: 100%;
  height: 100%;
  padding: 0px 20px;
}
.container {
  width: 100%;
  display: flex;
  height: calc(100% - 140px);
  padding: 20px 0px;
  gap: 20px;
}

.form {
  height: 40px;

  margin-bottom: 10px;
  .formItem {
    width: 100%;
    display: flex;
    align-items: center;
    .label {
      width: 120px;
      font-size: 14px;
      text-align: right;
      margin-right: 10px;
    }
  }
}
.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: right;
  padding: 12px 16px;
  background: #fff;

  z-index: 99999;
}

::v-deep .el-drawer__body {
  padding: 0;
}

::v-deep .el-tabs__header {
  margin: 0;
}
</style>
